import { render, staticRenderFns } from "./forget_password.vue?vue&type=template&id=12a434b8&scoped=true&"
import script from "./forget_password.vue?vue&type=script&lang=js&"
export * from "./forget_password.vue?vue&type=script&lang=js&"
import style0 from "./forget_password.vue?vue&type=style&index=0&id=12a434b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a434b8",
  null
  
)

export default component.exports